enum RequesterFieldType {
  CHECKBOX = 'CHECKBOX',
  IMAGE = 'IMAGE',
  TEXT = 'TEXT',
}

export default RequesterFieldType;
